/**
 * Theme Management — frontend enums / constants.
 * Mirrors the backend module constants so dropdowns and the DB agree.
 * Self-contained: does not touch any existing constants.
 */

export const THEME_TYPE_OPTIONS = [
  { value: "home", label: "Home" },
  { value: "lock", label: "Lock" },
];

export const WIDGET_SCREEN_OPTIONS = [
  { value: "home", label: "Home" },
  { value: "lock", label: "Lock" },
];

export const WIDGET_CATEGORY_OPTIONS = [
  { value: "Clock", label: "Clock" },
  { value: "Calendar", label: "Calendar" },
  { value: "Quotes", label: "Quotes" },
  { value: "Countdown", label: "Countdown" },
  { value: "Timer", label: "Timer" },
  { value: "Mixed", label: "Mixed" },
  { value: "Weather", label: "Weather" },
  { value: "Charging", label: "Charging" },
  { value: "Steps", label: "Steps" },
  { value: "Sleep", label: "Sleep" },
  { value: "Music", label: "Music" },
  { value: "Analog", label: "Analog" },
];

/** Master catalog of per-role text style roles (used by the Text Styles editor). */
export const TEXT_ROLE_OPTIONS = [
  { value: "time", label: "Time" },
  { value: "date", label: "Date" },
  { value: "month", label: "Month" },
  { value: "day", label: "Day" },
  { value: "weekday", label: "Weekday" },
  { value: "grid", label: "Grid" },
  { value: "temperature", label: "Temperature" },
  { value: "condition", label: "Condition" },
  { value: "hilo", label: "Hi/Lo" },
  { value: "location", label: "Location" },
  { value: "hourly", label: "Hourly" },
  { value: "weekly", label: "Weekly" },
  { value: "battery", label: "Battery" },
  { value: "label", label: "Label" },
  { value: "value", label: "Value" },
  { value: "unit", label: "Unit" },
  { value: "title", label: "Title" },
  { value: "duration", label: "Duration" },
  { value: "quality", label: "Quality" },
  { value: "days", label: "Days" },
  { value: "nowPlaying", label: "Now Playing" },
  { value: "track", label: "Track" },
  { value: "artist", label: "Artist" },
  { value: "playlist", label: "Playlist" },
  { value: "quote", label: "Quote" },
];

/** Default text-style roles auto-generated per widget category — mirrors the backend CATEGORY_TEXT_ROLES map exactly. */
export const CATEGORY_TEXT_ROLES = {
  Clock: ["time", "date"],
  Timer: ["time", "date"],
  Countdown: ["time", "date"],
  Calendar: ["month", "day", "weekday", "grid"],
  Weather: ["temperature", "condition", "hilo", "location", "hourly", "weekly"],
  Charging: ["battery", "time", "date"],
  Steps: ["label", "value", "unit", "title"],
  Sleep: ["title", "duration", "quality", "days"],
  Music: ["nowPlaying", "track", "artist", "playlist"],
  Quotes: ["quote"],
  Mixed: [],
  Analog: [],
};

export const TEMPERATURE_UNIT_OPTIONS = [
  { value: "celsius",    label: "Celsius" },
  { value: "fahrenheit", label: "Fahrenheit" },
  { value: "auto",       label: "Auto" },
];

/** Date/time format presets for the Text Styles editor's per-role Format dropdown. */
export const DATE_FORMAT_OPTIONS = [
  { value: "h:mm a", label: "12-hour", example: "4:10 PM" },
  { value: "h:mm", label: "12-hour, no AM/PM", example: "4:10" },
  { value: "HH:mm", label: "24-hour", example: "16:10" },
  { value: "EEEE", label: "Weekday", example: "Monday" },
  { value: "EEE", label: "Short weekday", example: "Mon" },
  { value: "MMM d, yyyy", label: "Full date", example: "May 30, 2026" },
  { value: "d MMM", label: "Day + month", example: "20 Oct" },
  { value: "d", label: "Day only", example: "20" },
  { value: "MMMM", label: "Month only", example: "October" },
  { value: "d MMMM, yyyy", label: "Long date", example: "20 October, 2026" },
];

/** Roles that render a date/time value — only these get the Format dropdown; it's optional/hidden for every other role. */
export const FORMAT_ROLES = ["time", "date", "month"];

export const FONT_WEIGHT_OPTIONS = [
  { value: "regular", label: "Regular" },
  { value: "medium", label: "Medium" },
  { value: "semibold", label: "Semibold" },
  { value: "bold", label: "Bold" },
];

export const WIDGET_SIZE_OPTIONS = [
  { value: "small", label: "Small" },
  { value: "medium", label: "Medium" },
  { value: "large", label: "Large" },
];

export const ALIGNMENT_OPTIONS = [
  { value: "left", label: "Left" },
  { value: "center", label: "Center" },
  { value: "right", label: "Right" },
];

export const VARIANT_SHAPE_OPTIONS = [
  { value: "circular", label: "Circular" },
  { value: "rectangular", label: "Rectangular" },
  { value: "inline", label: "Inline" },
];

export const PAGE_SIZE_OPTIONS = [10, 25, 50, 100];

/** Pretty-print an enum value for table cells. */
export const labelOf = (options, value) =>
  (options.find((o) => o.value === value) || {}).label || value || "-";
